import React, { useEffect, useState, useRef, useMemo } from "react";
import HeaderData from "../HeaderData";
import TabSelector from "../TabSelector";
import { getUpdateDate } from "../utils/monthNames";
import AvisosDeMantenimientoTable from "./AvisosDeMantemientoTable";
import Select from "react-select";
import { SingleOption, customStylesPedidos, parseBudat, parseDate } from "../utils/utils";
import DatePicker from "react-datepicker";
import PrintComponent from "../PrintComponent";
import ExportExcel from "../ExportExcel";
import { getPaginationItems, openBase64NewTab, setInstalalaciones, setPagadoresArcoprime } from "../utils/get";
import Pagination from "react-js-pagination";
import MantenimientoCard from "./MantenimientoCard";
import MantenimientoResponsiveCard from "./MantenimientoResponsiveCard";
import MantenimientoModal from "./MantenimientoModal";
import { hideGreyBackground, showGreyBackground } from "../utils/windows";
import SearchFilter from "../../assets/img/filter-avisos-mantencion.svg";
import OrdenarAvisosMantenimientoModal from "./OrdenarAvisosMantenimientoModal";
import OpcionesOrdenamientoModal from "./OpcionesOrdenamientoModal";

/* ---------------------------
   Helper components (OUTSIDE)
--------------------------- */

const PagadorFilter = ({ isArcoprime, selectedPagador, onChange, options }) => {
  if (!isArcoprime) return null;

  return (
    <div className={`filter`}>
      <div className="filter-title required-field">ID DE PAGADOR</div>
      <div className="filter-input">
        <Select
          className="eds-select"
          value={selectedPagador}
          onChange={onChange}
          closeMenuOnSelect={true}
          hideSelectedOptions={false}
          options={options}
          components={{
            SingleOption,
            IndicatorSeparator: () => null,
          }}
          isClearable={false}
          autosize={false}
          placeholder="Seleccionar"
          styles={customStylesPedidos}
        />
      </div>
    </div>
  );
};

const EdsFilter = ({ isArcoprime, selectedEds, onChange, options }) => (
  <div className={`filter ${isArcoprime && "mleft"}`}>
    <div className="filter-title required-field">ESTACIÓN DE SERVICIO</div>
    <div className="filter-input">
      <Select
        className="eds-select"
        value={selectedEds}
        onChange={onChange}
        closeMenuOnSelect={true}
        hideSelectedOptions={false}
        options={options}
        components={{
          SingleOption,
          IndicatorSeparator: () => null,
        }}
        isClearable={false}
        autosize={false}
        placeholder="Seleccionar"
        styles={customStylesPedidos}
      />
    </div>
  </div>
);

const EmptyMessage = ({ text }) => (
  <div className="order-data">
    <div className="important-message error">
      <span className="error-icon">!</span>
      <span>{text}</span>
    </div>
  </div>
);

const TabBuscarPorOrden = ({
  isArcoprime,
  allPagadores,
  selectedPagador,
  changePagador,
  selectedEds,
  changeEds,
  allEds,
  ordenValue,
  setOrdenValue,
  handleOrderEnter,
  orden,
  openFile,
}) => (
  <div className="order-container">
    <div className="order-options">
      <div className="filters-container">
        <PagadorFilter
          isArcoprime={isArcoprime}
          selectedPagador={selectedPagador}
          onChange={(e) => changePagador(e)}
          options={allPagadores}
        />

        <EdsFilter isArcoprime={isArcoprime} selectedEds={selectedEds} onChange={(e) => changeEds(e)} options={allEds} />

        <div className="filter mleft">
          <div className="filter-title required-field">NÚMERO DE ORDEN</div>
          <div className="filter-input">
            <input
              type="number"
              class="orden-input"
              id="orden-input"
              placeholder="Ej: 546465464"
              value={ordenValue}
              onChange={(e) => setOrdenValue(e.target.value)}
              onKeyDown={handleOrderEnter}
            ></input>
          </div>
        </div>
      </div>
    </div>

    {typeof orden === "undefined" && <></>}
    <div className="responsive-separator"></div>

    {orden && (
      <>
        {orden.vacio ? (
          <EmptyMessage text="No existen datos para este Nº de orden." />
        ) : (
          <MantenimientoCard orden={orden} openFile={openFile} tipo="aviso" />
        )}
      </>
    )}
  </div>
);

const TabBuscarPorAviso = ({
  isArcoprime,
  allPagadores,
  selectedPagador,
  changePagador,
  selectedEds,
  changeEds,
  allEds,
  avisoValue,
  setAvisoValue,
  handleAvisoEnter,
  aviso,
  openFile,
}) => (
  <div className="order-container">
    <div className="order-options">
      <div className="filters-container">
        <PagadorFilter
          isArcoprime={isArcoprime}
          selectedPagador={selectedPagador}
          onChange={(e) => changePagador(e)}
          options={allPagadores}
        />

        <EdsFilter isArcoprime={isArcoprime} selectedEds={selectedEds} onChange={(e) => changeEds(e)} options={allEds} />

        <div className="filter mleft">
          <div className="filter-title required-field">NÚMERO DE AVISO</div>
          <div className="filter-input">
            <input
              type="number"
              class="orden-input"
              id="aviso-input"
              placeholder="Ej: 546465464"
              value={avisoValue}
              onChange={(e) => setAvisoValue(e.target.value)}
              onKeyDown={handleAvisoEnter}
            ></input>
          </div>
        </div>
      </div>
      <div className="responsive-separator"></div>
    </div>

    {typeof aviso === "undefined" && (
      <>
        <h2>{/* Busca por número de aviso. Esperar si negocio define mensaje default. */}</h2>
      </>
    )}

    {aviso && (
      <>
        {aviso.vacio ? <EmptyMessage text="No existen datos para este Nº de aviso." /> : <MantenimientoCard orden={aviso} openFile={openFile} tipo="aviso" />}
      </>
    )}
  </div>
);

const TabBuscarPorFecha = ({
  isArcoprime,
  allPagadores,
  selectedPagador,
  changePagador,
  selectedEds,
  changeEds,
  allEds,
  filterText,
  setFilterText,
  fechaDesde,
  changeFechaDesde,
  fechaHasta,
  changeFechaHasta,
  getMaxDate,
  openOrdenarAvisosMantenimientoModal,
  tableRef,
  isROImpersonate,
  filteredAvisos,
  openedCards,
  setDisplayAvisoResponsiveModal,
  displayAvisoResponsiveModal,
  setOrdenResponsiveModal,
  setDistanceToTopResponsiveModal,
  setOpenedCards,
  avisos,
  setAvisos,
  setFilteredAvisos,
  paginationFilteredAvisos,
  setPaginationActivePage,
  setPaginationFilteredAvisos,
  openFile,
  paginationItemsPerPage,
  paginationActivePage,
  handlePageChange,
  labels,
}) => {
    
  const [extraPadding, setExtraPadding] = useState(0);

  const getExtraPadding = () => {
    let aux = 0;
    if (!(window.innerWidth < 1023)){
      setExtraPadding(aux);
      return aux;
    }

    if (displayAvisoResponsiveModal) {
      aux = ((openedCards * 305) + 410);
    }else{
      aux = (openedCards * 305);
    }
    setExtraPadding(aux);
    return aux;
  }

  useEffect(() => {
    getExtraPadding();
  }, [displayAvisoResponsiveModal, openedCards]);

  return(
    <>
      <div className="fecha-options mantenimiento-fecha-options">
        <div className="filters-container mantenimiento-filters-container">
          <PagadorFilter
            isArcoprime={isArcoprime}
            selectedPagador={selectedPagador}
            onChange={(e) => changePagador(e)}
            options={allPagadores}
          />

          <EdsFilter isArcoprime={isArcoprime} selectedEds={selectedEds} onChange={(e) => changeEds(e)} options={allEds} />

          <div className="filter only-tablet-search-input">
            <div className="filter-input search-input">
              <input type="search" className="search" value={filterText} placeholder="Buscar..." onChange={(e) => setFilterText(e.target.value)} />
              <img src={SearchFilter} alt="" className="search-filter-icon" />
            </div>
          </div>

          <div className="filter mleft not-tablet-search-input">
            <div className="filter-title required-field">FECHA DESDE</div>
            <div className="filter-input">
              <DatePicker
                className="fecha-input"
                locale="es"
                selected={fechaDesde}
                onChange={(e) => changeFechaDesde(e)}
                shouldCloseOnSelect={true}
                dateFormat="dd/MM/yyyy"
                maxDate={new Date()}
                placeholderText="Seleccionar"
              />
            </div>
          </div>

          <div className="filter mleft only-tablet-search-input">
            <div className="filter-title required-field">FECHA DESDE</div>
            <div className="filter-input">
              <DatePicker
                className="fecha-input"
                locale="es"
                selected={fechaDesde}
                onChange={(e) => changeFechaDesde(e)}
                shouldCloseOnSelect={true}
                dateFormat="dd/MM/yyyy"
                maxDate={new Date()}
                placeholderText="Seleccionar"
              />
            </div>
          </div>

          <div className="filter mleft date-avisos-tablet">
            <div className="filter-title required-field">FECHA HASTA</div>
            <div className="filter-input">
              <DatePicker
                className="fecha-input"
                locale="es"
                selected={fechaHasta}
                onChange={(e) => changeFechaHasta(e)}
                shouldCloseOnSelect={true}
                dateFormat="dd/MM/yyyy"
                maxDate={getMaxDate(fechaDesde)}
                minDate={fechaDesde}
                placeholderText="Seleccionar"
                disabled={fechaDesde ? false : true}
              />
            </div>
          </div>

          <div className="filter not-tablet-search-input mantenimiento-not-tablet-search-input">
            <div className="search-separator"></div>
            <div className="filter-input search-input">
              <input type="search" className="search" value={filterText} placeholder="Buscar..." onChange={(e) => setFilterText(e.target.value)} />
              <img src={SearchFilter} alt="" className="search-filter-icon" onClick={(e) => openOrdenarAvisosMantenimientoModal(e)} />
            </div>
          </div>
        </div>

        <div className="actions">
          <PrintComponent
            reff={tableRef}
            pageStyle="@page { size: auto; margin: 3mm; } @media print { body { -webkit-print-color-adjust: exact; padding: 0px !important; } }"
            isROImpersonate={isROImpersonate}
          />
          <ExportExcel data={filteredAvisos} labels={labels} isROImpersonate={isROImpersonate} />
        </div>
      </div>

      <div className="options-separator mantenimiento-options-separator"></div>

      {(typeof filteredAvisos === "undefined" || filteredAvisos.length === 0) && (
        <div className="no-orders-container">No existen avisos para la selección de filtros elegidos</div>
      )}

      {filteredAvisos?.length > 0 && (
        <div className="mantenimiento-responsive-cards-container" style={{ paddingBottom: `${extraPadding}px` }}>
          {filteredAvisos.map((aviso, key) => {
            return (
              <MantenimientoResponsiveCard
                key={aviso.NUMERO_AVISO.substring(4)}
                isOrden={false}
                aviso={aviso}
                openFile={openFile}
                setDisplayAvisoResponsiveModal={setDisplayAvisoResponsiveModal}
                setOrdenResponsiveModal={setOrdenResponsiveModal}
                setDistanceToTopResponsiveModal={setDistanceToTopResponsiveModal}
                setOpenedCards={setOpenedCards}
                openedCards={openedCards}
              />
            );
          })}
        </div>
      )}

      <AvisosDeMantenimientoTable
        tableRef={tableRef}
        avisos={avisos}
        setAvisos={setAvisos}
        filteredAvisos={filteredAvisos}
        setFilteredAvisos={setFilteredAvisos}
        filterText={filterText}
        paginationFilteredAvisos={paginationFilteredAvisos}
        setPaginationActivePage={setPaginationActivePage}
        setPaginationFilteredAvisos={setPaginationFilteredAvisos}
        openFile={openFile}
        paginationItemsPerPage={paginationItemsPerPage}
        paginationActivePage={paginationActivePage}
      />

      <>
        {avisos ? (
          <div className="pagination-container avisos-de-mantenimiento-pagination">
            <Pagination
              activePage={paginationActivePage}
              itemsCountPerPage={parseInt(paginationItemsPerPage)}
              totalItemsCount={filteredAvisos?.length}
              pageRangeDisplayed={5}
              onChange={(e) => handlePageChange(e)}
              hideFirstLastPages={true}
              linkClassPrev="prev"
              linkClassNext="next"
              prevPageText=""
              nextPageText=""
            />
          </div>
        ) : (
          <></>
        )}
      </>
    </>
  );
}

/* ---------------------------
   Main component
--------------------------- */

const AvisosDeMantemiento = ({
  rutConcesionario,
  token,
  pagador,
  cabecera,
  instalaciones,
  isROImpersonate,
  edsPortal,
  callServiceHandler,
}) => {
  const [updateDate, setUpdateDate] = useState();
  const [selectedTab, setSelectedTab] = useState(1);
  const [allEds, setAllEds] = useState([]);
  const [selectedEds, setSelectedEds] = useState();
  const [fechaDesde, setFechaDesde] = useState();
  const [fechaHasta, setFechaHasta] = useState();
  const [filterText, setFilterText] = useState("");
  const tableRef = useRef(null);

  // Data
  const [ordenValue, setOrdenValue] = useState("");
  const [orden, setOrden] = useState();
  const [avisoValue, setAvisoValue] = useState("");
  const [aviso, setAviso] = useState();
  const [avisos, setAvisos] = useState();
  const [filteredAvisos, setFilteredAvisos] = useState([]);

  // Guardamos el orden original (tal como llegó inicialmente)
  const originalAvisosRef = useRef([]);

  // Pagination
  const [paginationActivePage, setPaginationActivePage] = useState(1);
  const [paginationFilteredAvisos, setPaginationFilteredAvisos] = useState([]);
  const paginationItemsPerPage = parseInt(process.env.REACT_APP_PAGINATION_ITEMS_PER_PAGE);

  // Arcoprime
  const [isArcoprime, setIsArcoprime] = useState(false);
  const [allPagadores, setAllPagadores] = useState([]);
  const [selectedPagador, setSelectedPagador] = useState();

  // Responsive modal
  const [displayAvisoResponsiveModal, setDisplayAvisoResponsiveModal] = useState(false);
  const [ordenResponsiveModal, setOrdenResponsiveModal] = useState({});
  const [distanceToTopResponsiveModal, setDistanceToTopResponsiveModal] = useState(0);

  // Ordenamiento modales
  const [displayOrdenarAvisosMantenimientoModal, setDisplayOrdenarAvisosMantenimientoModal] = useState(false);
  const [distanceToTopOrdenarAvisosMantenimientoModal, setDistanceToTopOrdenarAvisosMantenimientoModal] = useState(0);

  const [displayOpcionesOrdenamientoModal, setDisplayOpcionesOrdenamientoModal] = useState(false);
  const [optionsModalTitle, setOptionsModalTitle] = useState("");

  const [nroAvisoFilterValue, setNroAvisoFilterValue] = useState({ label: "Seleccionar", value: "seleccionar" });
  const [fechaAvisoFilterValue, setFechaAvisoFilterValue] = useState({ label: "Seleccionar", value: "seleccionar" });
  const [prioridadFilterValue, setPrioridadFilterValue] = useState({ label: "Seleccionar", value: "seleccionar" });
  const [productoFilterValue, setProductoFilterValue] = useState({ label: "Seleccionar", value: "seleccionar" });

  const [openedCards, setOpenedCards] = useState(0);

  const labels = [
    ["Nº de Orden", "NUMERO_ORDEN"],
    ["Nº de Aviso", "NUMERO_AVISO"],
    ["Fecha de Aviso", "FECHA_AVISO"],
    ["Fecha de Cierre", "FECHA_CIERRE"],
    ["Descripción", "DESCRIPCION"],
    ["Prioridad", "PRIORIDAD"],
    ["Producto", "PRODUCTO"],
    ["Equipo", "EQUIPO"],
    ["Contratista", "CONTRATISTA"],
    ["Factura", "FACTURA"],
  ];

  const openOpcionesOrdenamientoModal = () => {
    setDisplayOpcionesOrdenamientoModal(true);
    showGreyBackground();
  };

  const closeOpcionesOrdenamientoModal = () => {
    setDisplayOpcionesOrdenamientoModal(false);
    hideGreyBackground();
  };

  const openOrdenarAvisosMantenimientoModal = (e) => {
    showGreyBackground();
    setDistanceToTopOrdenarAvisosMantenimientoModal(e.currentTarget.getBoundingClientRect().top);
    setDisplayOrdenarAvisosMantenimientoModal(true);
  };

  const closeOrdenarAvisosMantenimientoModal = () => {
    setDisplayOrdenarAvisosMantenimientoModal(false);
    hideGreyBackground();
  };

  async function changeEds(e) {
    reset();
    setSelectedEds(e);
  }

  function reset() {
    setAviso();
    setOrden();
    setFechaDesde();
    setFechaHasta();
    setAvisos();
    setFilteredAvisos([]);
    originalAvisosRef.current = [];
    setPaginationFilteredAvisos([]);
    setPaginationActivePage(1);
    setOrdenValue("");
    setAvisoValue("");
    setNroAvisoFilterValue({ label: "Seleccionar", value: "seleccionar" });
    setFechaAvisoFilterValue({ label: "Seleccionar", value: "seleccionar" });
    setPrioridadFilterValue({ label: "Seleccionar", value: "seleccionar" });
    setProductoFilterValue({ label: "Seleccionar", value: "seleccionar" });
  }

  const shouldEnableArcoprime = (env, rut) => {
    if (!rut) return false;
    return rut === "77215640-5";
  };

  useEffect(() => {
    if (!token) return;

    getUpdateDate(setUpdateDate);

    const env = process.env.REACT_APP_ENVIRONMENT;
    const enabled = shouldEnableArcoprime(env, rutConcesionario);

    if (enabled) setIsArcoprime(true);
  }, [token, rutConcesionario]);

  useEffect(() => {
    if (!instalaciones) return;
    if (instalaciones === "") return;
    if (isArcoprime) return;

    setInstalalaciones(instalaciones, setAllEds);
  }, [instalaciones, isArcoprime]);

  useEffect(() => {
    if (!edsPortal) return;
    setPagadoresArcoprime(edsPortal.data.user_eds, setAllPagadores);
  }, [edsPortal]);

  useEffect(() => {
    if (allPagadores.length === 1) changePagador(allPagadores[0]);
  }, [allPagadores]);

  function changePagador(e) {
    setSelectedPagador(e);
  }

  useEffect(() => {
    const run = async () => {
      if (!selectedPagador) return;

      const url =
        process.env.REACT_APP_PEDIDOS_API +
        "/pedidos/obtener-instalaciones-cliente?id_pagador=" +
        selectedPagador.value;

      const result = await callServiceHandler(url, "GET");
      if (result !== "error") setInstalalaciones(result.data, setAllEds);
    };

    run();
  }, [selectedPagador]);

  useEffect(() => {
    if (allEds && allEds.length > 0) changeEds(allEds[0]);
  }, [allEds]);

  function handleOrderEnter(e) {
    if (e.key === "Enter") getByOrden(ordenValue);
  }

  function handleAvisoEnter(e) {
    if (e.key === "Enter") getByAviso(avisoValue);
  }

  useEffect(() => {
    if (fechaHasta) getAvisos();
  }, [fechaHasta]);

  function handlePageChange(pageNumber) {
    getPaginationItems(filteredAvisos, pageNumber, setPaginationFilteredAvisos, setPaginationActivePage);
  }

  useEffect(() => {
    console.log("PAGINATED", paginationFilteredAvisos);
  }, [paginationFilteredAvisos]);

  useEffect(() => {
    if (filteredAvisos?.length > 0) console.log("FILTERED AVISOS", filteredAvisos);
  }, [filteredAvisos]);

  async function getByOrden(numeroOrden) {
    let url =
      process.env.REACT_APP_MANTENIMIENTO_API +
      "/mantenimiento/obtener-avisos?rut_concesionario=" +
      rutConcesionario +
      "&id_eds=" +
      selectedEds.value +
      "&orden=" +
      numeroOrden;

    let result = await callServiceHandler(url, "GET");
    console.log("AVISOO", result);

    if (result !== "error") {
      if (result.data.ORDENES.length === 0) {
        setOrden({ vacio: true });
        return;
      }

      const dataFinal = result.data.ORDENES[0];
      dataFinal["vacio"] = false;
      setOrden(dataFinal);
    }
  }

  async function getByAviso(numeroAviso) {
    let url =
      process.env.REACT_APP_MANTENIMIENTO_API +
      "/mantenimiento/obtener-avisos?rut_concesionario=" +
      rutConcesionario +
      "&id_eds=" +
      selectedEds.value +
      "&aviso=" +
      numeroAviso;

    let result = await callServiceHandler(url, "GET");
    console.log("AVISOO", result);

    if (result !== "error") {
      if (result.data.ORDENES.length === 0) {
        setAviso({ vacio: true });
        return;
      }

      const dataFinal = result.data.ORDENES[0];
      dataFinal["vacio"] = false;
      setAviso(dataFinal);
    }
  }

  async function getAvisos() {
    let url =
      process.env.REACT_APP_MANTENIMIENTO_API +
      "/mantenimiento/obtener-avisos?rut_concesionario=" +
      rutConcesionario +
      "&id_eds=" +
      selectedEds.value +
      "&fecha_desde=" +
      parseDate(fechaDesde) +
      "&fecha_hasta=" +
      parseDate(fechaHasta);

    let result = await callServiceHandler(url, "GET");
    console.log(result);

    if (result !== "error") {
      if (result.data.ORDENES.length === 0) {
        originalAvisosRef.current = [];
        setAvisos({ vacio: true });
        return;
      }

      const dataFinal = cleanAvisos(result.data.ORDENES);
      dataFinal["vacio"] = false;

      originalAvisosRef.current = Array.isArray(dataFinal) ? [...dataFinal] : [];
      setAvisos(dataFinal);
    }
  }

  function cleanAvisos(avisosdata) {
    const newAvisos = [];

    console.log("AVISOS DATA", avisosdata);

    avisosdata.map((aviso) => {
      const newAviso = {
        NUMERO_ORDEN: aviso.numero_orden,
        NUMERO_AVISO: aviso.numero_aviso,
        FECHA_AVISO: parseBudat(aviso.fecha_aviso),
        FECHA_CIERRE: aviso.fecha_cierre !== "0000-00-00" ? parseBudat(aviso.fecha_cierre) : "En Progreso",
        DESCRIPCION: aviso.descripcion,
        PRIORIDAD: aviso.prioridad !== "" ? aviso.prioridad : "N/A",
        PRODUCTO: aviso.producto,
        EQUIPO: aviso.equipo !== "" ? aviso.equipo : "N/A",
        FACTURA: aviso.factura ? aviso.factura : " ",
        TIENE_ADJUNTOS: aviso.tiene_adjuntos,
        ADJUNTOS: aviso.ADJUNTOS,
        CONTRATISTA: aviso.puesto_de_trabajo,
        URL: aviso.url,
      };
      newAvisos.push(newAviso);
    });

    return newAvisos;
  }

  function changeFechaDesde(e) {
    setFechaDesde(e);
    setFechaHasta();
  }

  function changeFechaHasta(e) {
    setFechaHasta(e);
  }

  async function openFile(adjunto) {
    console.log("ADJUNTO:", adjunto);

    let url =
      process.env.REACT_APP_MANTENIMIENTO_API +
      "/mantenimiento/obtener-adjunto?id_sap=" +
      adjunto.id_sap;

    let result = await callServiceHandler(url, "GET");
    console.log(result.data);

    if (result.data.error === true) {
      return true;
    }

    openBase64NewTab(result.data.body, result.data.tipo);
  }

  function getMaxDate(fechaD) {
    const now = new Date();
    const minMasUno = new Date(fechaD?.getFullYear() + 1, fechaD?.getMonth(), fechaD?.getDate());

    return now > minMasUno ? minMasUno : now;
  }

  // ---------------------------
  // FILTRO (BUSQUEDA) + PAGINACION
  // ---------------------------
  const applySearchFilter = (baseAvisos, text) => {
    if (!Array.isArray(baseAvisos)) return [];

    let avisosArr = baseAvisos;

    if (text && avisosArr?.length > 0) {
      const filterTextLower = text.toLowerCase().replaceAll(".", "");

      const fieldsToSearch = [
        "NUMERO_ORDEN",
        "NUMERO_AVISO",
        "FECHA_AVISO",
        "FECHA_CIERRE",
        "DESCRIPCION",
        "PRIORIDAD",
        "PRODUCTO",
        "EQUIPO",
        "FACTURA",
        "CONTRATISTA",
      ];

      avisosArr = avisosArr.filter((aviso) =>
        fieldsToSearch.some((field) => {
          const val = aviso[field];
          if (!val) return false;
          return val.toString().toLowerCase().includes(filterTextLower);
        })
      );
    }

    return avisosArr;
  };

  const recomputeFilteredAndPagination = (baseAvisos, text) => {
    const filtered = applySearchFilter(baseAvisos, text);
    setFilteredAvisos(filtered);

    if (filtered.length > 0) {
      getPaginationItems(filtered, 1, setPaginationFilteredAvisos, setPaginationActivePage);
      return;
    }

    setPaginationFilteredAvisos([]);
    setPaginationActivePage(1);
  };

  useEffect(() => {
    if (!Array.isArray(avisos)) {
      setFilteredAvisos([]);
      setPaginationFilteredAvisos([]);
      setPaginationActivePage(1);
      return;
    }

    recomputeFilteredAndPagination(avisos, filterText);
  }, [avisos]);

  useEffect(() => {
    if (Array.isArray(avisos)) recomputeFilteredAndPagination(avisos, filterText);
  }, [filterText]);

  // ---------------------------
  // ORDENAMIENTO
  // ---------------------------
  const parseDDMMYYYY = (ddmmyyyy) => {
    if (!ddmmyyyy || typeof ddmmyyyy !== "string") return null;
    const parts = ddmmyyyy.split("/");
    if (parts.length !== 3) return null;
    const [dd, mm, yyyy] = parts;
    const d = new Date(parseInt(yyyy, 10), parseInt(mm, 10) - 1, parseInt(dd, 10));
    if (isNaN(d.getTime())) return null;
    return d;
  };

  const normalizeText = (v) => (v ?? "").toString().toLowerCase();

  const compareText = (a, b, dir) => {
    const av = normalizeText(a);
    const bv = normalizeText(b);
    const res = av.localeCompare(bv, "es", { sensitivity: "base" });
    return dir === "DESC" ? -res : res;
  };

  const compareNumber = (a, b, dir) => {
    const an = parseInt((a ?? "0").toString(), 10) || 0;
    const bn = parseInt((b ?? "0").toString(), 10) || 0;
    const res = an - bn;
    return dir === "DESC" ? -res : res;
  };

  const compareDate = (a, b, dir) => {
    const ad = parseDDMMYYYY(a);
    const bd = parseDDMMYYYY(b);
    const at = ad ? ad.getTime() : 0;
    const bt = bd ? bd.getTime() : 0;
    const res = at - bt;
    return dir === "DESC" ? -res : res;
  };

  const isActiveOrden = (value) => {
    if (value == null) return false;
    if (value === "seleccionar") return false;
    return true;
  };

  const textDirFromUI = (uiDir) => (uiDir === "Z_A" ? "DESC" : "ASC");

  const buildAvisosComparators = (criteria = {}) => {
    const { nroAvisoDir, fechaAvisoDir, prioridadDir, productoDir } = criteria;

    const comparators = [
      isActiveOrden(nroAvisoDir) ? (a, b) => compareNumber(a.NUMERO_AVISO, b.NUMERO_AVISO, nroAvisoDir) : null,
      isActiveOrden(fechaAvisoDir) ? (a, b) => compareDate(a.FECHA_AVISO, b.FECHA_AVISO, fechaAvisoDir) : null,
      isActiveOrden(prioridadDir) ? (a, b) => compareText(a.PRIORIDAD, b.PRIORIDAD, textDirFromUI(prioridadDir)) : null,
      isActiveOrden(productoDir) ? (a, b) => compareText(a.PRODUCTO, b.PRODUCTO, textDirFromUI(productoDir)) : null,
      (a, b) => a.__idx - b.__idx,
    ];

    return comparators.filter(Boolean);
  };

  const chainCompare = (comparators, a, b) => {
    for (let i = 0; i < comparators.length; i += 1) {
      const res = comparators[i](a, b);
      if (res !== 0) return res;
    }
    return 0;
  };

  const makeAvisosComparator = (criteria) => {
    const comparators = buildAvisosComparators(criteria);
    return (a, b) => chainCompare(comparators, a, b);
  };

  const applyOrdenamiento = (baseAvisos, criteria = {}) => {
    if (!Array.isArray(baseAvisos)) return [];

    const withIdx = baseAvisos.map((item, idx) => ({ ...item, __idx: idx }));
    withIdx.sort(makeAvisosComparator(criteria));

    return withIdx.map(({ __idx, ...rest }) => rest);
  };

  const handleOrdenarClick = () => {
    const base = Array.isArray(originalAvisosRef.current) ? originalAvisosRef.current : [];
    if (base.length === 0) {
      closeOrdenarAvisosMantenimientoModal();
      return;
    }

    const ordered = applyOrdenamiento([...base], {
      nroAvisoDir: nroAvisoFilterValue?.value,
      fechaAvisoDir: fechaAvisoFilterValue?.value,
      prioridadDir: prioridadFilterValue?.value,
      productoDir: productoFilterValue?.value,
    });

    setAvisos(ordered);
    closeOrdenarAvisosMantenimientoModal();
  };

  const handleRestablecerOrden = () => {
    setNroAvisoFilterValue({ label: "Seleccionar", value: "seleccionar" });
    setFechaAvisoFilterValue({ label: "Seleccionar", value: "seleccionar" });
    setPrioridadFilterValue({ label: "Seleccionar", value: "seleccionar" });
    setProductoFilterValue({ label: "Seleccionar", value: "seleccionar" });

    const base = Array.isArray(originalAvisosRef.current) ? [...originalAvisosRef.current] : [];
    setAvisos(base);
  };

  function closeAvisoResponsiveModal() {
    setDisplayAvisoResponsiveModal(false);
    hideGreyBackground();
  }

  const tabContent = useMemo(() => {
    const commonProps = {
      isArcoprime,
      allPagadores,
      selectedPagador,
      changePagador,
      selectedEds,
      changeEds,
      allEds,
      openFile,
    };

    const tabs = {
      1: (
        <TabBuscarPorOrden
          {...commonProps}
          ordenValue={ordenValue}
          setOrdenValue={setOrdenValue}
          handleOrderEnter={handleOrderEnter}
          orden={orden}
        />
      ),
      2: (
        <TabBuscarPorAviso
          {...commonProps}
          avisoValue={avisoValue}
          setAvisoValue={setAvisoValue}
          handleAvisoEnter={handleAvisoEnter}
          aviso={aviso}
        />
      ),
      3: (
        <TabBuscarPorFecha
          {...commonProps}
          filterText={filterText}
          setFilterText={setFilterText}
          fechaDesde={fechaDesde}
          changeFechaDesde={changeFechaDesde}
          fechaHasta={fechaHasta}
          changeFechaHasta={changeFechaHasta}
          getMaxDate={getMaxDate}
          openOrdenarAvisosMantenimientoModal={openOrdenarAvisosMantenimientoModal}
          tableRef={tableRef}
          isROImpersonate={isROImpersonate}
          filteredAvisos={filteredAvisos}
          openedCards={openedCards}
          setDisplayAvisoResponsiveModal={setDisplayAvisoResponsiveModal}
          displayAvisoResponsiveModal={displayAvisoResponsiveModal}
          setOrdenResponsiveModal={setOrdenResponsiveModal}
          setDistanceToTopResponsiveModal={setDistanceToTopResponsiveModal}
          setOpenedCards={setOpenedCards}
          avisos={avisos}
          setAvisos={setAvisos}
          setFilteredAvisos={setFilteredAvisos}
          paginationFilteredAvisos={paginationFilteredAvisos}
          setPaginationActivePage={setPaginationActivePage}
          setPaginationFilteredAvisos={setPaginationFilteredAvisos}
          paginationItemsPerPage={paginationItemsPerPage}
          paginationActivePage={paginationActivePage}
          handlePageChange={handlePageChange}
          labels={labels}
        />
      ),
    };

    return tabs[selectedTab] || null;
  }, [
    selectedTab,
    isArcoprime,
    allPagadores,
    selectedPagador,
    selectedEds,
    allEds,
    ordenValue,
    orden,
    avisoValue,
    aviso,
    filterText,
    fechaDesde,
    fechaHasta,
    isROImpersonate,
    filteredAvisos,
    openedCards,
    avisos,
    paginationFilteredAvisos,
    paginationItemsPerPage,
    paginationActivePage,
  ]);

  return (
    <div className="pedidos-activos page">
      <div className="view-title">Mantenimiento</div>
      <div className="view-title-separator">|</div>
      <div className="view-subtitle">Avisos de Mantenimiento</div>
      <hr className="title-separator-line header-data-avisos-mantenimiento-separator" />

      <div className="header-data-avisos-mantenimiento-container">
        <HeaderData
          rutConcesionario={rutConcesionario}
          token={token}
          actualizacion={updateDate}
          cabecera={cabecera}
          callServiceHandler={callServiceHandler}
        />
      </div>

      <TabSelector
        tab1="Buscar por Nº Orden"
        tab2="Buscar por Nº Aviso"
        tab3="Buscar por Fecha"
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
        reset={reset}
      />

      {tabContent}

      <div className="modal-container">
        <MantenimientoModal
          displayModal={displayAvisoResponsiveModal}
          closeModal={closeAvisoResponsiveModal}
          distanceToTop={distanceToTopResponsiveModal}
          orden={ordenResponsiveModal}
          tipo="aviso"
          openFile={openFile}
        />
      </div>

      <OrdenarAvisosMantenimientoModal
        displayModal={displayOrdenarAvisosMantenimientoModal}
        setDisplayModal={setDisplayOrdenarAvisosMantenimientoModal}
        closeModal={closeOrdenarAvisosMantenimientoModal}
        distanceToTop={distanceToTopOrdenarAvisosMantenimientoModal}
        setOptionsModalTitle={setOptionsModalTitle}
        setNroAvisoFilterValue={setNroAvisoFilterValue}
        setFechaAvisoFilterValue={setFechaAvisoFilterValue}
        setPrioridadFilterValue={setPrioridadFilterValue}
        setProductoFilterValue={setProductoFilterValue}
        nroAvisoFilterValue={nroAvisoFilterValue}
        fechaAvisoFilterValue={fechaAvisoFilterValue}
        prioridadFilterValue={prioridadFilterValue}
        productoFilterValue={productoFilterValue}
        openOpcionesOrdenamientoModal={openOpcionesOrdenamientoModal}
        onOrdenar={handleOrdenarClick}
        onRestablecerOrden={handleRestablecerOrden}
      />

      <OpcionesOrdenamientoModal
        displayModal={displayOpcionesOrdenamientoModal}
        setDisplayModal={setDisplayOpcionesOrdenamientoModal}
        closeModal={closeOpcionesOrdenamientoModal}
        distanceToTop={distanceToTopOrdenarAvisosMantenimientoModal}
        toFilter={optionsModalTitle}
        setNroAvisoFilterValue={setNroAvisoFilterValue}
        setFechaAvisoFilterValue={setFechaAvisoFilterValue}
        setPrioridadFilterValue={setPrioridadFilterValue}
        setProductoFilterValue={setProductoFilterValue}
        nroAvisoFilterValue={nroAvisoFilterValue}
        fechaAvisoFilterValue={fechaAvisoFilterValue}
        prioridadFilterValue={prioridadFilterValue}
        productoFilterValue={productoFilterValue}
        setDisplayOrdenarAvisosMantenimientoModal={setDisplayOrdenarAvisosMantenimientoModal}
      />
    </div>
  );
};

export default AvisosDeMantemiento;
